import RowSectionTitle from './RowSectionTitle';

export default RowSectionTitle;
